module.exports = __webpack_public_path__ + "static/media/CanteenEliteBuyer.af8c6b48.png";